import {
  DRIFT_MODAL_DATA,
  FINDING_MODAL_DATA,
  WORKLOAD_MODAL_DATA,
} from "../keyframe-data";
import type { GraphModalKind } from "../graph-scene";
import { Modal, modalHeight } from "./modal";

interface ModalLayerProps {
  modal: GraphModalKind | null;
  x: number;
  y: number;
  w: number;
}

const MODAL_DATA = {
  workload: WORKLOAD_MODAL_DATA,
  drift: DRIFT_MODAL_DATA,
  finding: FINDING_MODAL_DATA,
} as const;

export function ModalLayer({ modal, x, y, w }: ModalLayerProps) {
  if (!modal) return null;

  const minH = Math.max(
    modalHeight(WORKLOAD_MODAL_DATA, w),
    modalHeight(DRIFT_MODAL_DATA, w),
    modalHeight(FINDING_MODAL_DATA, w),
  );

  return (
    <g data-modal-layer="true" data-modal-kind={modal}>
      <Modal data={MODAL_DATA[modal]} x={x} y={y} w={w} minH={minH} />
    </g>
  );
}
